import * as Yup from 'yup';
import { cpfValidator } from '../../utils/CpfValidator';
import dayjs from 'dayjs';

export const RegisterUnimedCampinasValidation = Yup.object({
  /*   numeroCartao: Yup.string().required('Cartão inválido ou incorreto'), */
  cpf: Yup.string().test('cpf-valid', 'Verifique se o CPF está correto', function (value) {
    return cpfValidator(value || '');
  }).required('Verifique se o CPF está correto'),
  dataNascimento: Yup.string()
    .required('Insira um data de nascimento válida e correta')
    .test(
      'valid-date-format',
      'Verifique se a data de nascimento está correta',
      value => {
        const parsedDate = dayjs(value, 'DD/MM/YYYY', true);
        return parsedDate.isValid();
      }
    ).test(
      'not-today-or-future',
      'Verifique se a data de nascimento está correta',
      value => {
        const parsedDate = dayjs(value, 'DD/MM/YYYY', true);
        return parsedDate.isValid() && parsedDate.isBefore(dayjs(), 'day');
      }
    ),
  /* email: Yup.string().email('E-mail inválido').required('E-mail inválido'),
  emailConfirmacao: Yup.string()
    .test('emails-match', 'Os e-mails digitados estão diferentes', function (value) {
      return this.parent.email === value;
    })
    .required('E-mail inválido'),
  cel: Yup.string()
    .required('Celular inválido')
    .matches(/(\d{2})(\d{0,5})(\d{0,4})/, 'Campo inválido ou incorreto.'),
  tel: Yup.string()
    .required('Telefone inválido')
    .matches(/(\d{2})(\d{0,4})(\d{0,4})/, 'Campo inválido ou incorreto.'), */
});
